import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { DBComponente } from "../../../../interfaces/SuperAdmin/Others/iDataComponentes";

interface Props {
  apps: DBComponente[];
  selectedApps: string[];
  isCreating: boolean;
  setSelectedApps: React.Dispatch<React.SetStateAction<string[]>>;
}

const AppsSection: FC<Props> = ({
  selectedApps,
  setSelectedApps,
  apps,
  isCreating,
}) => {
  // Seleccionar todos los usuarios
  const selectAllApps = () => {
    setSelectedApps(apps.map((app) => app.id_componente));
  };

  // Función para manejar la selección/deselección de un app
  const toggleApp = (id: string) => {
    setSelectedApps((prev) =>
      prev.includes(id) ? prev.filter((app) => app !== id) : [...prev, id]
    );
  };

  return (
    <Grid
      container
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Grid
        item
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Apps
        </Typography>
        <Checkbox
          color="primary"
          checked={selectedApps.length > 0}
          sx={{
            color: "#336B87",
            "&.Mui-checked": { color: "#336B87" },
          }}
          onChange={(e) => {
            if (e.target.checked) {
              selectAllApps();
            } else {
              setSelectedApps([]);
            }
          }}
        />
      </Grid>

      <Grid
        item
        sx={{
          marginTop: "8px",
          paddingTop: "8px",
          borderTop: "1px solid rgba(51, 107, 135, 0.5)",
          maxHeight: "350px",
          overflowY: "auto",
        }}
      >
        {apps.length > 0 ? (
          apps.map((app) => (
            <FormControlLabel
              key={app.id_componente}
              control={
                <Checkbox
                  checked={selectedApps.includes(app.id_componente)}
                  disabled={isCreating}
                  onChange={() => toggleApp(app.id_componente)}
                  sx={{
                    color: "#336B87",
                    "&.Mui-checked": { color: "#336B87" },
                  }}
                />
              }
              label={<Typography color="#000">{app.nombre}</Typography>}
              sx={{ display: "flex", alignItems: "center" }}
            />
          ))
        ) : (
          <Typography color="#73767E" fontStyle="italic" textAlign="center">
            No hay apps disponibles
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default AppsSection;
